<script setup>
import {defineEmits, defineProps, onMounted, ref, toRefs} from "vue"
import ImageTypeForm from "@/components/Blocks/Types/ImageTypeForm.vue";

const emit = defineEmits(['saveBlock'])

const props = defineProps({
  length: {},
	competitionId: {
		type: [String, Number],
		required: true
	}
});
const {length, competitionId} = toRefs(props);

const defaultObject = () => ({
  type: 'ImageRender',
  data: {
    value: '',
    label: '',
	  entity: '',
    description: ''
  },
  id: 0
});

const modalVisible = ref(false);
const object = ref(defaultObject());

onMounted(() => {
  object.value.id = length.value + 1
})

function addBlock() {
  modalVisible.value = true
}

function handleOk() {
  emit('saveBlock', object.value)
  modalVisible.value = false
  resetObject()
}

function handleCancel() {
  modalVisible.value = false
  resetObject()
}

function resetObject() {
  object.value = defaultObject()
  object.value.id = length.value + 1
}
</script>

<template>
  <div>
    <a-button @click="addBlock">Изображение</a-button>
  </div>
  <a-modal
      v-model:visible="modalVisible"
      :title="null"
      @ok="handleOk"
      @cancel="handleCancel"
      :destroyOnClose="false"
  >
    <ImageTypeForm v-model="object" :competitionId="competitionId" />
  </a-modal>
</template>

<style lang="scss" scoped>
</style>
